/**
 * Câu dịch có đoạn `<b>…</b>` (thay `t.rich` của next-intl native). Tách chuỗi thành nút React — không chèn HTML, nên
 * không có đường nào cho thẻ lạ từ catalog.
 */
export function ChuDam({ chu }: { chu: string }) {
  return (
    <>
      {chu.split(/<b>(.*?)<\/b>/g).map((phan, i) =>
        i % 2 ? (
          <strong key={i} className="font-semibold">
            {phan}
          </strong>
        ) : (
          <span key={i}>{phan}</span>
        ),
      )}
    </>
  );
}
